<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/salesrep/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <div>
                      <GmapMap v-if="geolocations.length>0"
                        :options="{
                          zoomControl: false,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: false,
                          disableDefaultUi: false
                        }"
                        :center="{lat: median.lat, lng: median.lng}"
                        :zoom="12"
                        style="width: 400px; height: 300px;"
                      >
                      <GmapMarker
                          v-for="(location, index) in geolocations"  
                          :key="index"
                          :position="{lat: parseFloat(location.lat), lng: parseFloat(location.lng)}"
                          :label="location.visitnum.toString()"
                          :clickable="true"
                          :draggable="false"
                          :icon= "getIcon(location)"
                          @click="openInfoWindowTemplate(location)"
                      />
                        <gmap-info-window
                            :options="{
                              maxWidth: 300,
                              pixelOffset: { width: 0, height: -35 }
                            }"
                            :position="infoWindow.position"
                            :opened="infoWindow.open"
                            @closeclick="infoWindow.open=false">
                            <div v-html="infoWindow.template"></div>
                        </gmap-info-window>
                        
                      </GmapMap>
                    </div>
              </v-card-text>
            </v-card>
          </v-col>  
        </v-row>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
            repareas: [],
            repvisits: [],
            geolocations: [],
            median: {lat: 0, lng: 0},
            infoWindow: {
                position: {lat: 0, lng: 0},
                open: false,
                template: ''
            },
            orange: 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png',
            orange1: 'http://maps.google.com/mapfiles/ms/icons/orange.png',
            yellow: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
            yellow1: 'http://maps.google.com/mapfiles/ms/icons/yellow.png',
            green: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
            green1: 'http://maps.google.com/mapfiles/ms/icons/green.png',
            blue: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
            blue1: 'http://maps.google.com/mapfiles/ms/icons/blue.png',
            purple: 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png',
            purple1: 'http://maps.google.com/mapfiles/ms/icons/purple.png',
            red: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
            red1: 'http://maps.google.com/mapfiles/ms/icons/red.png',
            pink: 'http://maps.google.com/mapfiles/ms/icons/pink-dot.png',
            pink1: 'http://maps.google.com/mapfiles/ms/icons/pink.png',
            ltblue: 'http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png',
          };
        },
        computed: {
          ...mapState('District', ['districts']),
          ...mapState('Location', ['locations']),
          ...mapState('Region', ['regions']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
        },
        methods: {
          ...mapActions('District', ['getDistrictsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          findMedian(){
            let lats = this.geolocations.map(location=>parseFloat(location.lat));
            let lngs = this.geolocations.map(location=>parseFloat(location.lng));
            lats.sort();
            lngs.sort();
            return {lat: lats[parseInt(lats.length/2)], lng: lngs[parseInt(lngs.length/2)]}
          },
          getIcon(item){
            let num = item.daynum;
            let icon = {url: null, scaledSize: {width: 45, height: 45}}


            console.log(num)
            if([1,15].includes(num)) icon.url = this.blue;
            else if([2,16].includes(num)) icon.url = this.red;
            else if([3,17].includes(num)) icon.url = this.orange;
            else if([4,18].includes(num)) icon.url = this.purple;
            else if([5,19].includes(num)) icon.url = this.pink;
            else if([6,20].includes(num)) icon.url = this.yellow;
            else if([7,21].includes(num)) icon.url = this.green;
            else if([8,22].includes(num)) icon.url = this.blue1;
            else if([9,23].includes(num)) icon.url = this.red1;
            else if([10,24].includes(num)) icon.url = this.orange1;
            else if([11,25].includes(num)) icon.url = this.purple1;
            else if([12,26].includes(num)) icon.url = this.pink1;
            else if([13,27].includes(num)) icon.url = this.yellow1;
            else if([14,28].includes(num)) icon.url = this.green1;
            else icon.url = this.ltblue;
            return icon;
          },
          openInfoWindowTemplate(item) {
            this.infoWindow.open = true;
            this.infoWindow.position = { lat: parseFloat(item.lat), lng: parseFloat(item.lng) }
            this.infoWindow.template = `<img src="${item.visitimage}" width="200">
                                        <p style="margin: 0"><b>${item.visitname}</b></p>
                                        <p style="margin: 0">Day: ${item.daynum} - Num: ${item.visitnum}</p>
                                        <br>`

            console.log(this.infoWindow);
            this.infoWindow.open = true
          },
          findGeolocations(){
            let results = [];
            let visits = this.map_daynum=='All' || this.map_daynum==null ? this.repvisits : this.repvisits.filter(x=>x.daynum== parseInt(this.map_daynum) );
            for(var i in visits){
              let visit = visits[i];
              let location = visit.geolocation.replace(" ", "");
              let lat = location.split(',')[0];
              let lng = location.split(',')[1];
              results.push({visitname: visit.visitname, visitimage: visit.visitimage, daynum: visit.daynum, visitnum: visit.visitnum, lat: lat, lng: lng });
            }
            this.geolocations = results;
            this.median = this.findMedian();
            return results;
          },
          getLast(visits){
            let result = visits.sort(function(a,b){return parseInt(a.visitnum)-parseInt(b.visitnum) }).slice(-1);
            return result[0]!=undefined ? result[0]['visitnum'] : 0
          }
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);
          this.repvisits = this.initvalue.visits;
          this.findGeolocations();
          if(!this.initvalue._id) this.$router.push({ name: 'SalesRepList' });
          if(this.districts.length==0) await this.getDistrictsRequest();
          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.townships.length==0) await this.getTownshipsRequest();
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
